
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const IDLE_TIMEOUT = 30 * 60 * 1000; // 30分钟不活动
const getLoginPath = () => (
  window.location.hostname.toLowerCase().startsWith('trade.')
  || window.location.pathname.startsWith('/trade')
    ? '/trade'
    : '/'
);

export const useIdleTimer = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const logout = () => {
    localStorage.clear();
    navigate(getLoginPath());
  };

  const resetTimer = () => {
    // 清除现有的计时器
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // 设置30分钟后自动登出
    timeoutRef.current = setTimeout(() => {
      logout();
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    // 检查用户是否已登录
    const token = localStorage.getItem('token');
    if (!token) {
      return;
    }

    // 监听的用户活动事件
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    // 添加事件监听器
    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // 初始化计时器
    resetTimer();

    // 监听 localStorage 变化 (用于多标签页同步)
    const handleStorageChange = (e) => {
      if (e.key === 'token' && !e.newValue) {
        // 如果 token 被清除,跳转到登录页
        navigate(getLoginPath());
      }
    };
    window.addEventListener('storage', handleStorageChange);

    // 清理函数
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
      window.removeEventListener('storage', handleStorageChange);
      
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [navigate]);
};
